import type { ReplyComposeSeed } from "hooks/use-email-compose";
import type { ReplyEmailItem } from "hooks/use-email-replies-api";

/**
 * 返信先 reply から ReplyComposeSeed を生成する.
 * フル機能モーダル / インライン返信ペインの両方から同じ seed を使うための共通化.
 * @param {ReplyEmailItem} reply 選択中リプライ
 * @return {ReplyComposeSeed} シード
 */
export function buildReplySeed(reply: ReplyEmailItem): ReplyComposeSeed {
  return {
    toEmail: reply.fromEmail,
    toName: reply.fromName ?? null,
    subject: reply.subject || "",
    replyEmailId: reply.id,
    salesPipelineId: reply.salesPipelineId,
    focusMatterId: reply.focusMatterId,
    inReplyToMessageId: reply.messageId,
    providerThreadId: reply.providerThreadId,
    references: reply.inReplyTo ? [reply.inReplyTo] : [],
  };
}
